<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="3"
                        maxlength="250"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A descrição é obrigatória
                    </b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Anexo</label>
                    <b-form-file
                        v-model="documento"
                        :state="Boolean(documento)"
                        placeholder="Selecione o anexo..."
                        browse-text="Selecionar"
                        ref="arquivoInput"
                    ></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
                >
                Salvar
            </b-button
            >
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ParcelamentoServicos from '../ParcelamentoServicos'

export default {
    props: {
        anexo: {
            type: Object,
            default: () => ({})
        },

        parcelamento: {
			type: Object,
			default: () => ({})
		},

        showModal: {
            type: Boolean,
            default: () => false
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],            
            descricao: '',
            documento: null,
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = [],
            this.descricao = '',
            this.documento = null,
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarSalvar() {
            let msg = 'Confirma a inserção do Anexo?'

            this.$swal({
                title: 'Anexo',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let anexoDto = {
                idContrato: this.$route.params.contratoId,
                descricao: this.descricao,
                documento: this.documento,
                idInvestimentoPrevistoContrato: this.parcelamento.idInvestimentoPrevistoContrato,
                idParcela: this.parcelamento.idParcelaInvestimentoPrevistoContrato,
            }

            let promisse = ParcelamentoServicos.inserirAnexo(anexoDto)

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAnexosAtualizados')
            this.fecharModal()
        },
    },

    created() {},

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        descricao: {
            required
        },

        documento: {
            required
        },
    }
}
</script>
<style scoped>
    .modal-footer {
        justify-content: flex-end;
        padding: 1rem 0 0 0;
        margin: 0.5rem 0 0 0;
        border-top: 1px solid #c8ced3;
    }
</style>
